import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import TestimonialItem from '../components/TestimonialItem'; 

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      image: "/img/testimonial-1.jpg",
      name: "Aisha Mohammed",
      profession: "Web Development Student",
      text: "Fundisha has been a game-changer for my career. The Web Development bootcamp was comprehensive, up-to-date, and the instructor was incredibly supportive. I landed a new job just weeks after completing the course!"
    },
    {
      id: 2,
      image: "/img/testimonial-2.jpg",
      name: "David Ochieng",
      profession: "Data Science Enthusiast",
      text: "I was new to data science, and the Python course provided the perfect entry point. The lessons are well-structured, and the hands-on projects helped solidify my understanding. Highly recommended!"
    },
    {
      id: 3,
      image: "/img/testimonial-3.jpg",
      name: "Fatima Yusuf",
      profession: "UI/UX Designer",
      text: "The UI/UX Design course exceeded my expectations. I loved the focus on practical skills and building a portfolio. The community is also fantastic, and I've made some great connections."
    },
     {
      id: 4,
      image: "/img/testimonial-4.jpg",
      name: "Samuel Eze",
      profession: "Marketing Professional",
      text: "The Digital Marketing Masterclass was exactly what I needed to level up my skills. The content is practical, relevant, and covers everything from SEO to social media advertising. My campaign results have improved dramatically."
    }
  ];

  return (
    <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
            <div className="text-center">
                <h6 className="section-title bg-white text-center text-primary px-3">Testimonial</h6>
                <h1 className="mb-5">Our Students Say!</h1>
            </div>
             <Carousel
                showArrows={true}
                infiniteLoop={true}
                showThumbs={false}
                showStatus={false}
                autoPlay={true}
                interval={6100}
                className="testimonial-carousel"
            >
                {testimonials.map(testimonial => (
                  <TestimonialItem 
                    key={testimonial.id}
                    image={testimonial.image}
                    name={testimonial.name}
                    profession={testimonial.profession}
                    text={testimonial.text}
                  />
                ))}
            </Carousel>
        </div>
    </div>
  );
};

export default Testimonials; 